function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/*
Impulse 0.2.0 © 2023 Ambitious Idea Labs
 */
var symbol = Symbol.for('impulse');

var Store = /*#__PURE__*/function () {
  function Store( // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ctor, name) {
    _classCallCheck(this, Store);

    this.ctor = ctor;
    this.name = name;
    this.map = new Map();
    this.ctor = ctor;
    this.name = name;
    this.initialize();
  }

  _createClass(Store, [{
    key: "add",
    value: function add(value) {
      var _a;

      (_a = this.value) === null || _a === void 0 ? void 0 : _a.add(value);
    }
  }, {
    key: "value",
    get: function get() {
      return this.map.get(this.name);
    }
  }, {
    key: "initialize",
    value: function initialize() {
      if (!Object.prototype.hasOwnProperty.call(this.ctor, symbol)) {
        this.ctor[symbol] = new Map();
      }

      this.map = this.ctor[symbol];
      if (this.map.has(this.name)) return;
      this.map.set(this.name, new Set());
    }
  }]);

  return Store;
}();

function property() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? String : _ref$type;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function (ctor, key) {
    var store = new Store(ctor, 'property');
    store.add({
      key: key,
      type: type
    });
  };
}

function registerElement(name) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function (ctor) {
    try {
      window.customElements.define(name, ctor); // @ts-expect-error Register

      window[ctor.name] = customElements.get(name);
    } catch (error) {
      if (!(error instanceof DOMException && error.name === 'NotSupportedError')) throw error;
    }
  };
}

function target() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function (ctor, key) {
    var store = new Store(ctor, 'target');
    store.add({
      key: key
    });
  };
}

function targets() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function (ctor, key) {
    var store = new Store(ctor, 'targets');
    store.add({
      key: key
    });
  };
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

/* global Reflect, Promise, SuppressedError, Symbol */


function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
}; // capture nos:                1               2                 3    4

var descriptorPattern = /^(?:(.+?)?(?:@(window|document))?->)?(.+)#(.+)?$/;

function parseActionDescriptor(_descriptor) {
  var descriptor = _descriptor.trim();

  var _ref2 = descriptor.match(descriptorPattern) || [],
      _ref3 = _slicedToArray(_ref2, 5),
      eventName = _ref3[1],
      eventTarget = _ref3[2],
      identifier = _ref3[3],
      methodName = _ref3[4];

  return {
    eventName: eventName,
    eventTarget: getEventTarget(eventTarget),
    methodName: methodName,
    identifier: identifier
  };
}

function getEventTarget(target) {
  if (target === 'window') {
    return window;
  } else if (target === 'document') {
    return document;
  }
}

var SetMap = /*#__PURE__*/function () {
  function SetMap() {
    _classCallCheck(this, SetMap);

    this.map = new Map();
  }

  _createClass(SetMap, [{
    key: "add",
    value: function add(key, value) {
      findOrCreate(this.map, key).add(value);
    }
  }, {
    key: "delete",
    value: function _delete(key, value) {
      var _a;

      findOrCreate(this.map, key).delete(value); // Delete map item

      if (((_a = this.get(key)) === null || _a === void 0 ? void 0 : _a.size) === 0) {
        this.map.delete(key);
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this.map.clear();
    }
  }, {
    key: "values",
    get: function get() {
      var sets = Array.from(this.map.values());
      return sets.reduce(function (values, set) {
        return values.concat(Array.from(set));
      }, []);
    }
  }, {
    key: "get",
    value: function get(key) {
      return this.map.get(key);
    }
  }, {
    key: "has",
    value: function has(key, value) {
      var _a;

      return !!((_a = this.get(key)) === null || _a === void 0 ? void 0 : _a.has(value));
    }
  }]);

  return SetMap;
}();

function findOrCreate(map, key) {
  var values = map.get(key);

  if (!values) {
    values = new Set();
    map.set(key, values);
  }

  return values;
}

var EventListener = /*#__PURE__*/function () {
  function EventListener(instance, eventTarget, eventName, methodName) {
    _classCallCheck(this, EventListener);

    this.instance = instance;
    this.eventTarget = eventTarget;
    this.eventName = eventName;
    this.methodName = methodName;
    this.instance = instance;
    this.eventTarget = eventTarget;
    this.eventName = eventName;
    this.methodName = methodName;
  }

  _createClass(EventListener, [{
    key: "start",
    value: function start() {
      this.eventTarget.addEventListener(this.eventName, this);
    }
  }, {
    key: "stop",
    value: function stop() {
      this.eventTarget.removeEventListener(this.eventName, this);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(event) {
      var fn = this.instance[this.methodName];

      if (typeof fn === 'function') {
        fn.call(this.instance, event);
      }
    }
  }]);

  return EventListener;
}();
/**
 * Returns the attribute's value as an array.
 * @example
 * <div data-action="foo bar"></div>
 *
 * const element = document.querySelector('div');
 * getAttributeValues(element, 'data-action');
 * //=> ['foo', 'bar']
 *
 *
 * <div data-action="foo bar"></div>
 *
 * const element = document.querySelector('div');
 * getAttributeValues(element, 'invalid');
 * //=> []
 */


function getAttributeValues(target, attributeName) {
  var _a;

  return ((_a = target.getAttribute(attributeName)) === null || _a === void 0 ? void 0 : _a.trim().split(/\s+/)) || [];
}

var ElementObserver = /*#__PURE__*/function () {
  function ElementObserver(element, delegate, observerOptions) {
    var _this = this;

    _classCallCheck(this, ElementObserver);

    this.element = element;
    this.delegate = delegate;
    this.observerOptions = observerOptions;
    this.started = false;
    this.element = element;
    this.delegate = delegate;
    this.observer = new MutationObserver(function (mutations) {
      return _this.processMutations(mutations);
    });
    this.observerOptions = observerOptions;
  }

  _createClass(ElementObserver, [{
    key: "start",
    value: function start() {
      if (!this.started) {
        this.started = true;
        this.observer.observe(this.element, Object.assign({
          childList: true,
          subtree: true
        }, this.observerOptions));
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.started) {
        this.observer.takeRecords();
        this.observer.disconnect();
        this.started = false;
      }
    }
  }, {
    key: "processMutations",
    value: function processMutations(mutations) {
      if (this.started) {
        var _iterator = _createForOfIteratorHelper(mutations),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var mutation = _step.value;
            this.processMutation(mutation);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  }, {
    key: "processMutation",
    value: function processMutation(mutation) {
      if (mutation.type === 'attributes' && mutation.target instanceof Element) {
        this.processAttributeChange(mutation.target, mutation.attributeName);
      } else if (mutation.type === 'childList') {
        this.processRemovedNodes(mutation.removedNodes);
        this.processAddedNodes(mutation.addedNodes);
      }
    }
  }, {
    key: "processAttributeChange",
    value: function processAttributeChange(element, attributeName) {
      if (attributeName) {
        this.delegate.elementAttributeChanged(element, attributeName);
      }
    }
  }, {
    key: "processRemovedNodes",
    value: function processRemovedNodes(nodes) {
      for (var _i2 = 0, _Array$from = Array.from(nodes); _i2 < _Array$from.length; _i2++) {
        var node = _Array$from[_i2];
        var element = this.elementFromNode(node);

        if (element) {
          this.delegate.elementDisconnected(element);
        }
      }
    }
  }, {
    key: "processAddedNodes",
    value: function processAddedNodes(nodes) {
      for (var _i3 = 0, _Array$from2 = Array.from(nodes); _i3 < _Array$from2.length; _i3++) {
        var node = _Array$from2[_i3];
        var element = this.elementFromNode(node);

        if (element && this.elementIsActive(element)) {
          this.delegate.elementConnected(element);
        }
      }
    }
  }, {
    key: "elementFromNode",
    value: function elementFromNode(node) {
      if (node.nodeType === Node.ELEMENT_NODE) {
        return node;
      }

      return undefined;
    }
  }, {
    key: "elementIsActive",
    value: function elementIsActive(element) {
      if (element.isConnected !== this.element.isConnected) {
        return false;
      }

      return this.element.contains(element);
    }
  }]);

  return ElementObserver;
}();

var AttributeObserver = /*#__PURE__*/function () {
  function AttributeObserver(instance, attributeName, delegate) {
    _classCallCheck(this, AttributeObserver);

    this.instance = instance;
    this.attributeName = attributeName;
    this.delegate = delegate;
    this.instance = instance;
    this.attributeName = attributeName;
    this.elementObserver = new ElementObserver(this.instance, this, {
      attributeFilter: [this.attributeName]
    });
    this.delegate = delegate;
  }

  _createClass(AttributeObserver, [{
    key: "start",
    value: function start() {
      this.elementObserver.start();
    }
  }, {
    key: "stop",
    value: function stop() {
      this.elementObserver.stop();
    }
  }, {
    key: "elementConnected",
    value: function elementConnected(element) {
      var elements = this.getMatchingElements(element);

      var _iterator2 = _createForOfIteratorHelper(elements),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var ele = _step2.value;
          this.delegate.elementConnected(ele);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "elementDisconnected",
    value: function elementDisconnected(element) {
      var elements = this.getMatchingElements(element);

      var _iterator3 = _createForOfIteratorHelper(elements),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var ele = _step3.value;
          this.delegate.elementDisconnected(ele);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "elementAttributeChanged",
    value: function elementAttributeChanged(element, attributeName) {
      var _a, _b;

      if (attributeName === this.attributeName) {
        (_b = (_a = this.delegate).elementAttributeChanged) === null || _b === void 0 ? void 0 : _b.call(_a, element, attributeName);
      }
    }
  }, {
    key: "getMatchingElements",
    value: function getMatchingElements(element) {
      var elements = Array.from(element.querySelectorAll("[".concat(this.attributeName, "]")));

      if (element.hasAttribute(this.attributeName)) {
        elements.unshift(element);
      }

      return elements;
    }
  }]);

  return AttributeObserver;
}();

var Scope = /*#__PURE__*/function () {
  function Scope(instance) {
    _classCallCheck(this, Scope);

    this.instance = instance;
    this.instance = instance;
  }

  _createClass(Scope, [{
    key: "findTarget",
    value: function findTarget(selector) {
      return this.instance.matches(selector) ? this.instance : this.getElements(selector).find(this.scopedTarget.bind(this)) || null;
    }
  }, {
    key: "findTargets",
    value: function findTargets(selector) {
      return [].concat(_toConsumableArray(this.instance.matches(selector) ? [this.instance] : []), _toConsumableArray(this.getElements(selector).filter(this.scopedTarget.bind(this))));
    }
  }, {
    key: "scopedTarget",
    value: function scopedTarget(element) {
      return element.closest(this.identifier) === this.instance;
    }
  }, {
    key: "getElements",
    value: function getElements(selector) {
      return Array.from(this.instance.querySelectorAll(selector));
    }
  }, {
    key: "identifier",
    get: function get() {
      return this.instance.identifier;
    }
  }]);

  return Scope;
}();

var ATTRIBUTE_NAME = 'data-action';

var Action = /*#__PURE__*/function () {
  function Action(instance) {
    _classCallCheck(this, Action);

    this.instance = instance;
    this.eventListenerMap = new SetMap();
    this.instance = instance;
    this.scope = new Scope(this.instance);
    this.attributeObserver = new AttributeObserver(this.instance, ATTRIBUTE_NAME, this);
  }

  _createClass(Action, [{
    key: "start",
    value: function start() {
      var _this2 = this;

      this.attributeObserver.start();
      this.actionableElements.forEach(function (element) {
        return _this2.bindActions(element);
      });
    }
  }, {
    key: "stop",
    value: function stop() {
      this.eventListenerMap.values.forEach(function (eventListener) {
        return eventListener.stop();
      });
      this.eventListenerMap.clear();
      this.attributeObserver.stop();
    }
  }, {
    key: "elementConnected",
    value: function elementConnected(element) {
      this.bindActions(element);
    }
  }, {
    key: "elementDisconnected",
    value: function elementDisconnected(element) {
      this.unbindActions(element);
    }
  }, {
    key: "elementAttributeChanged",
    value: function elementAttributeChanged(element) {
      this.unbindActions(element);
      this.bindActions(element);
    }
  }, {
    key: "bindActions",
    value: function bindActions(element) {
      var _this3 = this;

      var descriptors = getAttributeValues(element, ATTRIBUTE_NAME);
      descriptors.forEach(function (descriptor) {
        var _parseActionDescripto = parseActionDescriptor(descriptor),
            eventName = _parseActionDescripto.eventName,
            eventTarget = _parseActionDescripto.eventTarget,
            methodName = _parseActionDescripto.methodName,
            identifier = _parseActionDescripto.identifier;

        if (eventName && identifier === _this3.identifier && methodName && _this3.actionableElements.includes(element)) {
          var eventListener = new EventListener(_this3.instance, eventTarget || element, eventName, methodName);

          _this3.eventListenerMap.add(element, eventListener);

          eventListener.start();
        }
      });
    }
  }, {
    key: "unbindActions",
    value: function unbindActions(element) {
      var _this4 = this;

      var eventListeners = this.eventListenerMap.get(element);
      if (!eventListeners) return;
      eventListeners.forEach(function (eventListener) {
        eventListener.stop();

        _this4.eventListenerMap.delete(element, eventListener);
      });
    }
  }, {
    key: "actionableElements",
    get: function get() {
      return this.scope.findTargets("[".concat(ATTRIBUTE_NAME, "]"));
    }
  }, {
    key: "identifier",
    get: function get() {
      return this.instance.identifier;
    }
  }]);

  return Action;
}();

var STRING_CAMELIZE_REGEXP_1 = /(-|_|\.|\s)+(.)?/g;
var STRING_CAMELIZE_REGEXP_2 = /(^|\/)([A-Z])/g;
var STRING_DASHERIZE_REGEXP = /[ _]/g;
var STRING_DECAMELIZE_REGEXP = /([a-z\d])([A-Z])/g;
/**
 * Returns the lowerCamelCase form of a string.
 *
 * @example
 * camelize('innerHTML');
 * //=> innerHTML
 *
 * camelize('action_name');
 * //=> actionName
 *
 * camelize('css-class-name');
 * //=> cssClassName
 *
 * camelize('my favorite items');
 * //=> myFavoriteItems
 *
 * camelize('My Favorite Items');
 * //=> myFavoriteItems
 *
 * camelize('private-docs/owner-invoice');
 * //=> privateDocs/ownerInvoice
 */

function camelize(value) {
  return value.replace(STRING_CAMELIZE_REGEXP_1, function (_match, _separator, chr) {
    return chr ? chr.toUpperCase() : '';
  }).replace(STRING_CAMELIZE_REGEXP_2, function (match) {
    return match.toLowerCase();
  });
}
/**
 * Replaces underscores, spaces, or camelCase with dashes.
 *
 * @example
 * dasherize('innerHTML');
 * //=> inner-html
 *
 * dasherize('action_name');
 * //=> action-name
 */


function dasherize(value) {
  return decamelize(value).replace(STRING_DASHERIZE_REGEXP, '-');
}
/**
 * Converts a camelized string into all lower case separated by underscores.
 *
 * @example
 * decamelize('innerHTML');
 * //=> inner_html
 */


function decamelize(value) {
  return value.replace(STRING_DECAMELIZE_REGEXP, '$1_$2').toLowerCase();
}
/**
 * Returns the output of JSON.parse or fallbacks to a specified default value.
 *
 * @example
 * parseJSON('[]');
 * //=> []
 *
 * parseJSON(undefined, '');
 * //=> ''
 */


function parseJSON(value) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (!value) return fallback;

  try {
    return JSON.parse(value);
  } catch (_a) {
    return fallback;
  }
}

var Property = /*#__PURE__*/function () {
  function Property(instance) {
    _classCallCheck(this, Property);

    this.instance = instance;
    this.instance = instance;
    this.store = new Store(Object.getPrototypeOf(this.instance), 'property');
  }

  _createClass(Property, [{
    key: "start",
    value: function start() {
      var _iterator4 = _createForOfIteratorHelper(this.properties.entries()),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _ref6 = _step4.value;

          var _ref5 = _slicedToArray(_ref6, 1);

          var _ref5$ = _ref5[0];
          var key = _ref5$.key;
          var type = _ref5$.type;
          this.initializeProperty(key, type);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, {
    key: "stop",
    value: function stop() {//
    }
  }, {
    key: "initializeProperty",
    value: function initializeProperty(key, type) {
      var _a;

      var attributeName = dasherize(key);
      var defaultValue = this.instance[key];
      var descriptor = Object.assign({
        configurable: true
      }, descriptorProperties(this.instance, attributeName, type));
      Object.defineProperty(this.instance, key, descriptor);

      if (!this.instance.hasAttribute(attributeName)) {
        (_a = descriptor.set) === null || _a === void 0 ? void 0 : _a.call(descriptor, defaultValue);
      }
    }
  }, {
    key: "properties",
    get: function get() {
      return this.store.value;
    }
  }]);

  return Property;
}();

function descriptorProperties(element, attributeName, type) {
  switch (type) {
    case Number:
      return {
        get: function get() {
          return Number(element.getAttribute(attributeName) || 0);
        },
        set: function set(value) {
          return element.setAttribute(attributeName, (value || 0).toString());
        }
      };

    case Boolean:
      return {
        get: function get() {
          return element.hasAttribute(attributeName) && element.getAttribute(attributeName) !== 'false';
        },
        set: function set(value) {
          // Simply toggling the attribute will not work.
          if (value) {
            element.setAttribute(attributeName, '');
          } else {
            element.removeAttribute(attributeName);
          }
        }
      };

    case Array:
      return {
        get: function get() {
          return JSON.parse(element.getAttribute(attributeName) || '[]');
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        set: function set(value) {
          return element.setAttribute(attributeName, JSON.stringify(value) || '[]');
        }
      };

    case Object:
      return {
        get: function get() {
          return JSON.parse(element.getAttribute(attributeName) || '{}');
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        set: function set(value) {
          return element.setAttribute(attributeName, JSON.stringify(value) || '{}');
        }
      };

    default:
      return {
        get: function get() {
          return element.getAttribute(attributeName) || '';
        },
        set: function set(value) {
          return element.setAttribute(attributeName, value || '');
        }
      };
  }
}

var Target = /*#__PURE__*/function () {
  function Target(instance) {
    _classCallCheck(this, Target);

    this.instance = instance;
    this.instance = instance;
    this.store = new Store(Object.getPrototypeOf(this.instance), 'target');
    this.scope = new Scope(this.instance);
    this.targetsByName = new SetMap();
    this.attributeObserver = new AttributeObserver(this.instance, 'data-target', this);
  }

  _createClass(Target, [{
    key: "start",
    value: function start() {
      var _this5 = this;

      this.attributeObserver.start();
      this.keys.forEach(function (key) {
        return _this5.initializeKey(key);
      });
    }
  }, {
    key: "stop",
    value: function stop() {
      var _this6 = this;

      this.keys.forEach(function (key) {
        return _this6.terminateKey(key);
      });
      this.attributeObserver.stop();
    }
  }, {
    key: "elementConnected",
    value: function elementConnected(target) {
      var tokens = getAttributeValues(target, 'data-target');

      var _iterator5 = _createForOfIteratorHelper(tokens),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var token = _step5.value;

          var _token$split = token.split('.'),
              _token$split2 = _slicedToArray(_token$split, 2),
              identifier = _token$split2[0],
              key = _token$split2[1];

          if (key && !this.targetsByName.has(key, target) && identifier === this.identifier && this.keys.includes(key) && this.findTarget(key) === target) {
            this.targetsByName.add(key, target);
            this.defineProperty(key, this.findTarget(key));
            this.invokeConnectedCallback(key, target);
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  }, {
    key: "elementDisconnected",
    value: function elementDisconnected(target) {
      var tokens = getAttributeValues(target, 'data-target');

      var _iterator6 = _createForOfIteratorHelper(tokens),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var token = _step6.value;

          var _token$split3 = token.split('.'),
              _token$split4 = _slicedToArray(_token$split3, 2),
              identifier = _token$split4[0],
              key = _token$split4[1];

          if (key && this.targetsByName.has(key, target) && identifier === this.identifier && this.keys.includes(key)) {
            this.invokeDisconnectedCallback(key, target);
            this.defineProperty(key, null);
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }
  }, {
    key: "initializeKey",
    value: function initializeKey(key) {
      var target = this.findTarget(key);

      if (target) {
        this.targetsByName.add(key, target);
      }

      this.defineProperty(key, target);

      if (target) {
        this.invokeConnectedCallback(key, target);
      }
    }
  }, {
    key: "terminateKey",
    value: function terminateKey(key) {
      var target = this.findTarget(key);

      if (target) {
        this.invokeDisconnectedCallback(key, target);
      }
    }
  }, {
    key: "findTarget",
    value: function findTarget(key) {
      return this.scope.findTarget("[data-target~=\"".concat(this.identifier, ".").concat(key, "\"]"));
    }
  }, {
    key: "defineProperty",
    value: function defineProperty(key, target) {
      var descriptor = {
        configurable: true,
        get: function get() {
          return target;
        }
      };
      Object.defineProperty(this.instance, key, descriptor);
    }
  }, {
    key: "invokeConnectedCallback",
    value: function invokeConnectedCallback(key, target) {
      var fn = this.instance["".concat(key, "Connected")];

      if (typeof fn === 'function') {
        fn.call(this.instance, target);
      }
    }
  }, {
    key: "invokeDisconnectedCallback",
    value: function invokeDisconnectedCallback(key, target) {
      var fn = this.instance["".concat(key, "Disconnected")];

      if (typeof fn === 'function') {
        fn.call(this.instance, target);
      }
    }
  }, {
    key: "keys",
    get: function get() {
      return Array.from(this.store.value).map(function (_ref7) {
        var key = _ref7.key;
        return key;
      });
    }
  }, {
    key: "identifier",
    get: function get() {
      return this.instance.identifier;
    }
  }]);

  return Target;
}();

var Targets = /*#__PURE__*/function () {
  function Targets(instance) {
    _classCallCheck(this, Targets);

    this.instance = instance;
    this.instance = instance;
    this.store = new Store(Object.getPrototypeOf(this.instance), 'targets');
    this.scope = new Scope(this.instance);
    this.targetsByName = new SetMap();
    this.attributeObserver = new AttributeObserver(this.instance, 'data-target', this);
  }

  _createClass(Targets, [{
    key: "start",
    value: function start() {
      var _this7 = this;

      this.attributeObserver.start();
      this.keys.forEach(function (key) {
        return _this7.initializeKey(key);
      });
    }
  }, {
    key: "stop",
    value: function stop() {
      var _this8 = this;

      this.keys.forEach(function (key) {
        return _this8.terminateKey(key);
      });
      this.attributeObserver.stop();
    }
  }, {
    key: "elementConnected",
    value: function elementConnected(target) {
      var tokens = getAttributeValues(target, 'data-target');

      var _iterator7 = _createForOfIteratorHelper(tokens),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var token = _step7.value;

          var _token$split5 = token.split('.'),
              _token$split6 = _slicedToArray(_token$split5, 2),
              identifier = _token$split6[0],
              key = _token$split6[1];

          if (key && !this.targetsByName.has(key, target) && identifier === this.identifier && this.keys.includes(key) && this.findTargets(key).includes(target)) {
            this.targetsByName.add(key, target);
            this.defineProperty(key, this.findTargets(key));
            this.invokeConnectedCallback(key, target);
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    }
  }, {
    key: "elementDisconnected",
    value: function elementDisconnected(target) {
      var tokens = getAttributeValues(target, 'data-target');

      var _iterator8 = _createForOfIteratorHelper(tokens),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var token = _step8.value;

          var _token$split7 = token.split('.'),
              _token$split8 = _slicedToArray(_token$split7, 2),
              identifier = _token$split8[0],
              key = _token$split8[1];

          if (key && this.targetsByName.has(key, target) && identifier === this.identifier && this.keys.includes(key)) {
            this.invokeDisconnectedCallback(key, target);
            this.defineProperty(key, this.findTargets(key));
          }
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
    }
  }, {
    key: "initializeKey",
    value: function initializeKey(key) {
      var _this9 = this;

      var targets = this.findTargets(key);
      targets.forEach(function (target) {
        return _this9.targetsByName.add(key, target);
      });
      this.defineProperty(key, targets);
      targets.forEach(function (target) {
        return _this9.invokeConnectedCallback(key, target);
      });
    }
  }, {
    key: "terminateKey",
    value: function terminateKey(key) {
      var _this10 = this;

      var targets = this.findTargets(key);
      targets.forEach(function (target) {
        return _this10.invokeDisconnectedCallback(key, target);
      });
    }
  }, {
    key: "findTargets",
    value: function findTargets(key) {
      return this.scope.findTargets("[data-target~=\"".concat(this.identifier, ".").concat(key, "\"]"));
    }
  }, {
    key: "defineProperty",
    value: function defineProperty(key, targets) {
      var descriptor = {
        configurable: true,
        get: function get() {
          return targets;
        }
      };
      Object.defineProperty(this.instance, key, descriptor);
    }
  }, {
    key: "invokeConnectedCallback",
    value: function invokeConnectedCallback(key, target) {
      var fn = this.instance["".concat(key, "Connected")];

      if (typeof fn === 'function') {
        fn.call(this.instance, target);
      }
    }
  }, {
    key: "invokeDisconnectedCallback",
    value: function invokeDisconnectedCallback(key, target) {
      var fn = this.instance["".concat(key, "Disconnected")];

      if (typeof fn === 'function') {
        fn.call(this.instance, target);
      }
    }
  }, {
    key: "keys",
    get: function get() {
      return Array.from(this.store.value).map(function (_ref8) {
        var key = _ref8.key;
        return key;
      });
    }
  }, {
    key: "identifier",
    get: function get() {
      return this.instance.identifier;
    }
  }]);

  return Targets;
}();

var ImpulseElement = /*#__PURE__*/function (_HTMLElement) {
  _inherits(ImpulseElement, _HTMLElement);

  var _super = _createSuper(ImpulseElement);

  function ImpulseElement() {
    var _this11;

    _classCallCheck(this, ImpulseElement);

    _this11 = _super.apply(this, arguments);
    _this11.property = new Property(_assertThisInitialized(_this11));
    _this11.targets = new Targets(_assertThisInitialized(_this11));
    _this11.target = new Target(_assertThisInitialized(_this11));
    _this11.action = new Action(_assertThisInitialized(_this11));
    _this11._started = false;
    return _this11;
  }

  _createClass(ImpulseElement, [{
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return domReady();

              case 2:
                customElements.upgrade(this); // Order is important

                this.property.start(); // Resolve all undefined elements before initializing the target/targets so that property references can be resolved
                // to the assigned value.

                _context.next = 6;
                return this._resolveUndefinedElements();

              case 6:
                this.targets.start();
                this.target.start();
                this.action.start();
                this._started = true;
                this.setAttribute('data-impulse-element', '');
                this.connected();

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }

      return connectedCallback;
    }()
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, _oldValue, _newValue) {
      if (!this._started || _oldValue === _newValue) return;
      var camelizedName = camelize(name);
      var fn = this["".concat(camelizedName, "Changed")];
      if (typeof fn !== 'function') return;
      var store = new Store(Object.getPrototypeOf(this), 'property');
      var propertyArray = Array.from(store.value).map(function (_ref9) {
        var key = _ref9.key,
            type = _ref9.type;
        return {
          key: key,
          type: type
        };
      });
      var property = propertyArray.find(function (_ref10) {
        var key = _ref10.key;
        return key === camelizedName;
      });

      if (!property) {
        throw new Error("Unregistered attribute changed: ".concat(name, ". Register the attribute using the @property() decorator."));
      }

      var _attributeValueTransf = attributeValueTransformer(_newValue, _oldValue, property.type),
          newValue = _attributeValueTransf.newValue,
          oldValue = _attributeValueTransf.oldValue;

      fn.call(this, newValue, oldValue);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      // Order is important
      this.action.stop();
      this.target.stop();
      this.targets.stop();
      this.property.stop();
      this.disconnected();
      this._started = false;
    }
  }, {
    key: "connected",
    value: function connected() {// Override in your subclass to respond when the element is connected to the DOM.
    }
  }, {
    key: "disconnected",
    value: function disconnected() {// Override in your subclass to respond when the element is removed from the DOM.
    }
    /**
     * Emits a custom event from the element.
     */

  }, {
    key: "emit",
    value: function emit(name) {
      var _a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _a$target = _a.target,
          target = _a$target === void 0 ? this : _a$target,
          _a$prefix = _a.prefix,
          prefix = _a$prefix === void 0 ? this.identifier : _a$prefix,
          _a$detail = _a.detail,
          detail = _a$detail === void 0 ? {} : _a$detail,
          rest = __rest(_a, ["target", "prefix", "detail"]);

      var eventName = prefix ? "".concat(prefix, ":").concat(name) : name;
      var event = new CustomEvent(eventName, Object.assign({
        bubbles: true,
        composed: true,
        detail: detail
      }, rest));
      target.dispatchEvent(event);
      return event;
    }
  }, {
    key: "identifier",
    get: function get() {
      return this.tagName.toLowerCase();
    }
  }, {
    key: "_resolveUndefinedElements",
    value: function () {
      var _resolveUndefinedElements2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var undefinedElements, promises;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                undefinedElements = Array.from(this.querySelectorAll(':not(:defined)'));
                promises = undefinedElements.map(function (element) {
                  return customElements.whenDefined(element.localName);
                });
                _context2.next = 4;
                return Promise.all(promises);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _resolveUndefinedElements() {
        return _resolveUndefinedElements2.apply(this, arguments);
      }

      return _resolveUndefinedElements;
    }()
  }], [{
    key: "observedAttributes",
    get: function get() {
      var store = new Store(this.prototype, 'property');
      return Array.from(store.value).map(function (_ref11) {
        var key = _ref11.key;
        return dasherize(key);
      });
    }
  }]);

  return ImpulseElement;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

function attributeValueTransformer(_newValue, _oldValue, type) {
  switch (type) {
    case Boolean:
      {
        var transform = function transform(value) {
          return value !== null && value !== 'false';
        };

        return {
          newValue: transform(_newValue),
          oldValue: transform(_oldValue)
        };
      }

    case Number:
      return {
        newValue: Number(_newValue),
        oldValue: Number(_oldValue)
      };

    case Array:
      return {
        newValue: parseJSON(_newValue, []),
        oldValue: parseJSON(_oldValue, [])
      };

    case Object:
      return {
        newValue: parseJSON(_newValue, {}),
        oldValue: parseJSON(_oldValue, {})
      };

    default:
      return {
        newValue: _newValue,
        oldValue: _oldValue
      };
  }
}

function domReady() {
  return new Promise(function (resolve) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        return resolve();
      });
    } else {
      resolve();
    }
  });
}

export { ImpulseElement, property, registerElement, target, targets };